/**
 * [筛选查询表单-容器]
 * @author: Fu Xiaochun
 * @date: 2021-11-09 
 */

import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';

function FilterForm(props){

    return (
        <div className={styles.filterBox}>{props.children}</div>
    );
}

FilterForm.propTypes = {
    children: PropTypes.node
};

export default FilterForm;